import { combineReducers, configureStore } from '@reduxjs/toolkit'
import activityReducer from './Activity/ActivityReducer'
import curriculumReducer from './Curriculum/CurriculumReducer'
import pageReducer from './Dashboard/PageReducer'
import productReducer from './Product/ProductReducer'
import userReducer from './Dashboard/UserReducer'
import classroomReducer from './Classroom/ClassroomReducer'
import organizationReducer from './Organization/OrganizationReducer'
import studentReducer from './Student/StudentReducer'
import classroomModalReducer from './Modals/ClassroomModalReducer.js'
import programReducer from './Program/ProgramReducer'
import programListReducer from './Program/ProgramListReducer'
import filtersReducer from './Filters/FilterReducer'
import stepsReducer from './Steps/StepReducer'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { AppMiddleware } from './AppMiddleware'
/** Sphero EDU Editor Reducers */

// const persistConfig = {
//   key: 'root',
//   storage
// }

const persistClassroomConfig = {
  key: 'classroom',
  storage,
  whitelist: ['tags', 'classCode', 'classroom', 'activeItem']
}

const persistAuthenticationConfig = {
  key: 'authentication',
  storage,
  whitelist: ['isLoggedIn', 'user', 'classType']
}

const persistActivityConfig = {
  key: 'activity',
  storage,
  whitelist: ['assignment']
}

const rootReducer = combineReducers({
  activity: persistReducer(persistActivityConfig, activityReducer),
  classroom: persistReducer(persistClassroomConfig, classroomReducer),
  curriculum: curriculumReducer,
  organization: organizationReducer,
  page: pageReducer,
  product: productReducer,
  student: studentReducer,
  authentication: persistReducer(persistAuthenticationConfig, userReducer),
  classroomModal: classroomModalReducer,
  program: programReducer,
  programlist: programListReducer,
  filters: filtersReducer,
  steps: stepsReducer
})
// const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: rootReducer,
  middleware: [
    AppMiddleware
  ]
})

export const dispatch = persistStore(store).dispatch
